// libs
import {
  subDays,
  subMonths,
  subYears,
  isSameDay,
  eachDayOfInterval,
  isSameMonth,
  eachMonthOfInterval,
  eachYearOfInterval,
  isSameYear,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  startOfWeek,
  endOfWeek,
  eachWeekOfInterval,
  isSameWeek,
  subWeeks,
} from 'date-fns';
import { formatDate } from 'app-shared/lib/utils/date.utils';
// App
import { TimePeriodsConfigs } from './filters.interfaces';

export enum TIME_PERIOD {
  DAY = 'Jour',
  WEEK = 'Semaine',
  MONTH = 'Mois',
  YEAR = 'Année',
  CUSTOM = 'Personnalisée',
}

export const MONDAY_WEEK_START = { weekStartsOn: 1 } as const;

export const startOfMondayWeek = (date: Date | number): Date => startOfWeek(date, MONDAY_WEEK_START);

export const endOfMondayWeek = (date: Date | number): Date => endOfWeek(date, MONDAY_WEEK_START);

export const DISPLAYED_DURATIONS = {
  [TIME_PERIOD.DAY]: 7,
  [TIME_PERIOD.WEEK]: 3,
  [TIME_PERIOD.MONTH]: 12,
  [TIME_PERIOD.YEAR]: 2,
};

export const TIME_PERIODS_CONFIG: (isSmallScreen: boolean) => TimePeriodsConfigs = (isSmallScreen: boolean) => {
  const dayFormat = (isSmallScreen && 'dd/MM') || 'ccc dd/MM';
  const weekDayFormat = (isSmallScreen && 'dd') || 'ccc dd/MM';

  return {
    [TIME_PERIOD.DAY]: {
      startOfPeriodHandler: startOfDay,
      endOfPeriodHandler: endOfDay,
      subPeriodsHandler: subDays,
      isSamePeriodHandler: isSameDay,
      eachPeriodOfIntervalHandler: eachDayOfInterval,
      formatHandler: (date: Date) => formatDate(date, dayFormat),
    },
    [TIME_PERIOD.WEEK]: {
      startOfPeriodHandler: startOfMondayWeek,
      endOfPeriodHandler: endOfMondayWeek,
      subPeriodsHandler: subWeeks,
      isSamePeriodHandler: (dateLeft: Date | number, dateRight: Date | number) =>
        isSameWeek(dateLeft, dateRight, MONDAY_WEEK_START),
      eachPeriodOfIntervalHandler: (interval: Interval) => eachWeekOfInterval(interval, MONDAY_WEEK_START),
      formatHandler: (date: Date) =>
        `${formatDate(startOfMondayWeek(date), weekDayFormat)} - ${formatDate(endOfMondayWeek(date), weekDayFormat)}`,
    },
    [TIME_PERIOD.MONTH]: {
      startOfPeriodHandler: startOfMonth,
      endOfPeriodHandler: endOfMonth,
      subPeriodsHandler: subMonths,
      isSamePeriodHandler: isSameMonth,
      eachPeriodOfIntervalHandler: eachMonthOfInterval,
      formatHandler: (date: Date, isFirstDate: boolean, isLastDate: boolean) =>
        formatDate(date, (!isSmallScreen && (isFirstDate || isLastDate) && 'MMM yyy') || 'MMM'),
    },
    [TIME_PERIOD.YEAR]: {
      startOfPeriodHandler: startOfYear,
      endOfPeriodHandler: endOfYear,
      subPeriodsHandler: subYears,
      isSamePeriodHandler: isSameYear,
      eachPeriodOfIntervalHandler: eachYearOfInterval,
      formatHandler: (date: Date) => formatDate(date, 'yyyy'),
    },
  };
};
